<div class='ot-progress-bar-container'>
  <mat-progress-bar mode="determinate" [value]="value"></mat-progress-bar>
</div>